import { RgbaColor } from "react-colorful";

export const stringToRgaColor = (color: string | undefined, transparency: number | undefined) => {
    if (!color) {
      color = '#FFFFFF';
    }

    if (!transparency) {
      transparency = 0.75;
    }

    color = color.replace('#', '');

    return {
      r: parseInt(color?.substring(0, 2) || '0', 16),
      g: parseInt(color?.substring(2, 4) || '0', 16),
      b: parseInt(color?.substring(4, 6) || '0', 16),
      a: transparency || 0.75,
    };
  };

export const isRgbaColor = (value: RgbaColor | string): value is RgbaColor => {
  return (
    typeof value === 'object' &&
    value !== null &&
    'r' in value &&
    'g' in value &&
    'b' in value &&
    'a' in value &&
    typeof value.r === 'number' &&
    typeof value.g === 'number' &&
    typeof value.b === 'number' &&
    typeof value.a === 'number'
  );
};

export const toTwoDigitHex = (value: number) => {
  return value.toString(16).padStart(2, '0').toUpperCase();
};
